var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { DriverLogFactory } from './DriverLog';
import { Timeouts } from './Timeouts';
import { UdpCommandSocket } from './UdpCommandSocket';
export function doUdpMulticastQuery(driverName, queryName, options, responseHandler) {
    var _a;
    return __awaiter(this, void 0, void 0, function* () {
        const timeouts = new Timeouts();
        const logFactory = new DriverLogFactory(driverName);
        const log = logFactory.channel(queryName);
        const socket = new UdpCommandSocket(logFactory, Object.assign(Object.assign({}, options.udpCommandSocketOptions), { port: options.queryPort }));
        yield socket.connect(options.queryAddress);
        yield socket.bind((_a = options.bindPort) !== null && _a !== void 0 ? _a : options.queryPort, options.bindAddress);
        if (options.broadcast) {
            yield socket.setBroadcast(true);
        }
        const discoveryPromise = new Promise((resolve, reject) => __awaiter(this, void 0, void 0, function* () {
            var _b;
            const results = [];
            const timeout = timeouts.create();
            const id = socket.registerAsync({
                match: (message) => message,
                callback: (message, address, port) => {
                    const result = responseHandler(message, address, port);
                    if (result !== undefined)
                        results.push(result);
                },
            });
            timeout.set(() => {
                socket.unregisterAsync(id);
                timeout.destroy();
                resolve(results);
            }, (_b = options.timeoutMs) !== null && _b !== void 0 ? _b : 10000);
            try {
                yield socket.sendAsync(options.queryCommand);
            }
            catch (error) {
                log.error(error);
            }
        }));
        const results = yield discoveryPromise;
        socket.close();
        return results;
    });
}
